export const hint = "💡";
export const percent = "%";
export const asterisk = "*";
export const plus = "+";
export const kwhPerM2Year = "kWh/m²·year";
export const x = "x";
export const m2 = "m²";
export const kwh = "kWh";
export const celsius = "°C";
